import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const Home = () => {
    const productCategories = [
        {
            title: "Two-Wheeler Oils",
            description: "Premium engine oils for motorcycles and scooters",
            image: "/logo/product.jpeg",
            link: "/products#two-wheeler"
        },
        {
            title: "Car Engine Oils",
            description: "High-performance lubricants for passenger vehicles",
            image: "/logo/product.jpeg",
            link: "/products#car"
        },
        {
            title: "Commercial Vehicle Oils",
            description: "Heavy-duty oils for trucks and buses",
            image: "/logo/map.jpeg",
            link: "/products#commercial"
        },
        {
            title: "Industrial Lubricants",
            description: "Specialized oils for industrial machinery",
            image: "/logo/map1.jpeg",
            link: "/products#industrial"
        }
    ];

    const testimonials = [
        {
            name: "Rajesh Kumar",
            role: "Fleet Manager",
            company: "ABC Transport",
            text: "MapLube oils have significantly improved our fleet's performance and reduced maintenance costs."
        },
        {
            name: "Priya Sharma",
            role: "Service Center Owner",
            company: "Quick Service",
            text: "Our customers trust MapLube products for their vehicles. Quality and performance are exceptional."
        },
        {
            name: "Amit Patel",
            role: "Dealership Owner",
            company: "Patel Motors",
            text: "MapLube's dealer support and product quality have helped us grow our business significantly."
        }
    ];

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1>Premium Lubricants for Optimal Performance</h1>
                        <p>MapLube delivers high-quality engine oils and lubricants that protect your engines and maximize efficiency. Trusted by professionals across India.</p>
                        <div className="hero-buttons">
                            <Link to="/products" className="btn btn-primary">Explore Products</Link>
                            <Link to="/dealership" className="btn btn-secondary">Become a Dealer</Link>
                        </div>
                    </div>
                    <div className="hero-image">
                        <img src="/logo/original_logo.jpeg" alt="MapLube Products" />
                    </div>
                </div>
            </section>

            {/* Introduction Section */}
            <section className="intro">
                <div className="container">
                    <div className="intro-content">
                        <div className="intro-text">
                            <h2>Why Choose MapLube?</h2>
                            <div className="features">
                                <div className="feature">
                                    <div className="feature-icon">🛡️</div>
                                    <h3>Quality Assurance</h3>
                                    <p>ISO certified manufacturing with rigorous quality control standards</p>
                                </div>
                                <div className="feature">
                                    <div className="feature-icon">⚡</div>
                                    <h3>Performance</h3>
                                    <p>Engineered for maximum efficiency and engine protection</p>
                                </div>
                                <div className="feature">
                                    <div className="feature-icon">🌱</div>
                                    <h3>Innovation</h3>
                                    <p>Advanced formulations using cutting-edge technology</p>
                                </div>
                                <div className="feature">
                                    <div className="feature-icon">🤝</div>
                                    <h3>Trust</h3>
                                    <p>Trusted by millions of vehicle owners across India</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Product Categories */}
            <section className="product-categories">
                <div className="container">
                    <h2>Our Product Range</h2>
                    <div className="categories-grid">
                        {productCategories.map((category, index) => (
                            <div key={index} className="category-card">
                                <div className="category-image">
                                    <img src={category.image} alt={category.title} />
                                </div>
                                <div className="category-content">
                                    <h3>{category.title}</h3>
                                    <p>{category.description}</p>
                                    <Link to={category.link} className="btn btn-outline">Learn More</Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Industries Section */}
            <section className="industries">
                <div className="container">
                    <h2>Industries We Serve</h2>
                    <div className="industries-grid">
                        <div className="industry">
                            <div className="industry-icon">🚗</div>
                            <h3>Automotive</h3>
                            <p>Passenger vehicles, commercial vehicles, and motorcycles</p>
                        </div>
                        <div className="industry">
                            <div className="industry-icon">🚜</div>
                            <h3>Agriculture</h3>
                            <p>Tractors, harvesters, and agricultural machinery</p>
                        </div>
                        <div className="industry">
                            <div className="industry-icon">🏭</div>
                            <h3>Industrial</h3>
                            <p>Manufacturing equipment and industrial machinery</p>
                        </div>
                        <div className="industry">
                            <div className="industry-icon">🚛</div>
                            <h3>Transportation</h3>
                            <p>Logistics, fleet management, and transportation</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section className="testimonials">
                <div className="container">
                    <h2>What Our Customers Say</h2>
                    <div className="testimonials-grid">
                        {testimonials.map((testimonial, index) => (
                            <div key={index} className="testimonial-card">
                                <div className="testimonial-content">
                                    <p>"{testimonial.text}"</p>
                                </div>
                                <div className="testimonial-author">
                                    <h4>{testimonial.name}</h4>
                                    <p>{testimonial.role} at {testimonial.company}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Experience MapLube Quality?</h2>
                        <p>Join our network of satisfied customers and dealers across India</p>
                        <div className="cta-buttons">
                            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
                            <Link to="/dealership" className="btn btn-secondary">Become a Dealer</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
